import { store, loading, computed, action } from '~/common/mobx.decorator'
import { SEARCH_JOB_QUERY } from '~/common/apollo/queries/jobs.query'
import { CollectionCursorStore } from '../collection.cursor.store'
import { mappingSkillName } from '~/common/helpers/mapping.helper'
import { omit } from 'lodash'

@store()
class FeaturedJobStore extends CollectionCursorStore {
	constructor() {
		super(SEARCH_JOB_QUERY, 'searchJobs', ['totalCount'])
		this.name = 'featuredJobStore'
	}

	@loading
	@action
	fetchData = (isReload, filterCondition, paging = {}, field = undefined) => {
		const dataFilter = mappingSkillName(filterCondition)

		return this.load(isReload, {
			filter: {
				...omit(dataFilter, ['locationStates', 'locationCities']),
				jobPriority: '1',
			},
			...paging,
			...(field && { field, order: 'desc' }),
		})
	}

	@computed
	get totalCount() {
		return this.pageInfo.totalCount
	}
}

const featuredJobStore = new FeaturedJobStore()
export { featuredJobStore, FeaturedJobStore }
